// extracted by mini-css-extract-plugin
export default {"filters":"SearchFilters_filters__nIX8a","filter":"SearchFilters_filter__DW1hf"};